export default __webpack_public_path__ + "static/media/7insta.304de196.jpg";